import { render, staticRenderFns } from "./QuotaStatementTab.vue?vue&type=template&id=24027cb5&scoped=true"
import script from "./QuotaStatementTab.vue?vue&type=script&lang=js"
export * from "./QuotaStatementTab.vue?vue&type=script&lang=js"
import style0 from "./QuotaStatementTab.vue?vue&type=style&index=0&id=24027cb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24027cb5",
  null
  
)

export default component.exports